export class OverviewProjectUpdateAPI {
  constructor(Client) {
    this.Client = Client;
  }

  all = () => {
    return this.Client.get('/project-updates').then(response => {
      if (!response || !response.data) return false;
      return response.data;
    });
  };
}

export default OverviewProjectUpdateAPI;
